import { resizeSliderArrows } from './color-books';

window.sliders = function sliders() { };

sliders.init = function() {

  if ($('#home-image-slider').length !== 0) {
    $('#home-image-slider').slick({
      arrows: false,
      accessibility: false,
      asNavFor: '#home-promo-slider'
    });
    $('#home-promo-slider').slick({
      arrows: false,
      dots: true,
      asNavFor: '#home-image-slider'
    });
  }

  if ($('#advisorSliderPromo').length !== 0) {
    $('#advisorSliderPromo').find('.c-advisorStep').slick({
      slide: '.c-advisorStep__slide',
      arrows: false,
      infinite: true,
      mobileFirst: true,
      centerMode: true,
      centerPadding: '120px',
      responsive: [
        {
          breakpoint: 457,
          settings: {
            slidesToShow: 3,
            centerPadding: '60px'
          }
        },
        {
          breakpoint: 770,
        //  settings: 'unslick'
          settings: {
            slidesToShow: 5,
            centerMode: false
          }
        }
      ]
    });
  }

  if ($('#three-column-slider').length !== 0) {
    $('#three-column-slider').slick({
      arrows: false,
      dots: true,
      infinite: true,
      mobileFirst: true,
      centerMode: true,
      slidesToShow: 1,
      slide: '.o-card',
      centerPadding: '60px',
      responsive: [
        {
          breakpoint: 500,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            infinite: false
          }
        },
        {
          breakpoint: 770,
          settings: 'unslick'
        }
      ]
    });
  }

  $('.constrained-width-carousel').each(function() {
    // Only init Slick for this instance of carousel if more than one slide
    // Additional mark-up added by Slick when not a functioning slider, fails
    // BoIA audit
    const isMultipleSlides = $(this).find('.slider-block').length > 1;
    const isSwatchCarousel = $(this).hasClass('multi-item-swatch-carousel');
    if (isSwatchCarousel && isMultipleSlides) {
      $(this).slick({
        dots: false,
        infinite: true,
        centerMode: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      });
    } else if (!isSwatchCarousel && isMultipleSlides) {
      $(this).slick({
        slide: '.slider-block',
        dots: $('#cw-carousel .slider-block').length !== 1,
        arrows: true,
        appendArrows: $('.slider-control'),
        appendDots: $('.slider-control'),
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
      });
    }
  });
}
